import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看");

import { computed, ref } from 'vue';
import { getAttractApplyList } from '@/request';
import { getVexTableProps, dateFormat } from '@/config';
import { ElMessage, ElMessageBox } from 'element-plus';
import ApplyDetailModal from './component/ApplyDetailModal.vue';
export default {
  name: 'AttractInvestApply',

  setup(__props) {
    const showDetailModal = ref(false);
    const form = ref({
      prodName: '',
      time: []
    });
    const id = ref();
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'prodName',
        title: '申请品种',
        width: '200px',
        showOverflow: true
      }, {
        field: 'prodId',
        title: '品种ID',
        width: '200px',
        showOverflow: true
      }, {
        field: 'linkMan',
        title: '申请人姓名',
        width: '150px',
        showOverflow: true
      }, {
        field: 'linkPhone',
        title: '联系方式',
        width: '150px',
        showOverflow: true
      }, {
        field: 'loginName',
        title: '登录账号',
        width: '150px',
        showOverflow: true
      }, {
        field: 'agentAreaCodes',
        title: '代理区域',
        width: '200px',
        showOverflow: true,

        formatter({
          cellValue
        }) {
          return cellValue || '-';
        }

      }, {
        field: 'teamsCaleType',
        title: '团队人数',
        width: '200px',
        showOverflow: true
      }, {
        field: 'applyTime',
        title: '申请时间',
        width: '200px',
        showOverflow: true
      }, {
        title: '操作',
        field: 'operation',
        width: '200px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getAttractApplyList(_objectSpread(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, form.value), {}, {
              startTime: form.value.time && form.value.time[0] ? form.value.time[0] : '',
              endTime: form.value.time && form.value.time[1] ? form.value.time[1] : ''
            })).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });

    function reset() {
      form.value = {
        prodName: '',
        time: []
      };
      table.value.commitProxy('reload');
    }

    function see(row) {
      showDetailModal.value = true;
      id.value = row.applyId;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "申请品种"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.prodName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.prodName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "申请时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.time,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.time = $event),
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": _unref(dateFormat),
                "unlink-panels": ""
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        previewImg: _withCtx(({
          row
        }) => [_createVNode(_component_el_image, {
          style: {
            "width": "70px",
            "height": "70px"
          },
          src: row.slideshowUrl,
          "preview-src-list": [row.slideshowUrl],
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "success",
          onClick: $event => see(row)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(ApplyDetailModal, {
        id: id.value,
        modelValue: showDetailModal.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showDetailModal.value = $event)
      }, null, 8, ["id", "modelValue"])]);
    };
  }

};